import React, { useCallback, useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, QuoteIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { SectionHeading } from './shared/SectionHeading';
const A1 = 'https://cdn.magicpatterns.com/patterns/generated-images/26867317-615b-4aee-bbe1-f8601b45d196.jpg';
const A2 = 'https://cdn.magicpatterns.com/patterns/generated-images/bbc5cc94-35a7-4067-b168-1502ce17c04b.jpg';
const A3 = 'https://cdn.magicpatterns.com/patterns/generated-images/17fba966-bcb8-4605-bc88-988034caf11d.jpg';
interface Testimonial {
  name: string;
  role: string;
  photo: string;
  quote: string;
}
const testimonials: Testimonial[] = [{
  name: 'Amira H.',
  role: 'Kćerka korisnice',
  photo: A2,
  quote: 'Golden Care nam je pružio mir kakav dugo nismo imali. Njegovateljica za moju majku je pravi dragulj — profesionalna, topla i uvijek dostupna.'
}, {
  name: 'Senad K.',
  role: 'Sin korisnika',
  photo: A1,
  quote: 'Organizacija je bila munjevita, a komunikacija transparentna od prvog dana. Napokon se ne brinemo — otac je u sigurnim rukama.'
}, {
  name: 'Lejla M.',
  role: 'Porodica korisnika',
  photo: A3,
  quote: 'Individualan pristup i istinska briga. Osjećali smo da nismo samo klijenti, već porodica. Preporučujem svima od srca.'
}];
export function Testimonials() {
  const [index, setIndex] = useState(0);
  const go = useCallback((dir: 1 | -1) => setIndex(i => (i + dir + testimonials.length) % testimonials.length), []);
  useEffect(() => {
    const id = setInterval(() => go(1), 6500);
    return () => clearInterval(id);
  }, [go]);
  const t = testimonials[index];
  return <section className="relative w-full overflow-hidden bg-white py-20 lg:py-28" data-id="element-263">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-264">
        <SectionHeading eyebrow="Iskustva porodica" title="Riječi povjerenja" subtitle="Ono što porodice govore o saradnji sa Golden Care." data-id="element-265" />

        <div className="relative mt-14" data-id="element-266">
          <AnimatePresence mode="wait" data-id="element-267">
            <motion.figure key={index} initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -24
          }} transition={{
            duration: 0.5,
            ease: [0.22, 1, 0.36, 1]
          }} className="glass relative rounded-[2rem] p-8 shadow-luxury ring-1 ring-gold/10 sm:p-12" data-id="element-268">
              <QuoteIcon className="mb-6 h-10 w-10 text-gold/40" data-id="element-269" />
              <div className="mb-6 flex gap-1" data-id="element-270">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" data-id="element-271" />)}
              </div>
              <blockquote className="font-display text-xl font-medium leading-relaxed text-ink text-balance sm:text-2xl" data-id="element-272">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4" data-id="element-273">
                <img src={t.photo} alt={t.name} loading="lazy" className="h-14 w-14 rounded-full object-cover ring-2 ring-gold/40" data-id="element-274" />
                <span data-id="element-275">
                  <span className="block font-semibold text-ink" data-id="element-276">{t.name}</span>
                  <span className="text-sm text-muted" data-id="element-277">{t.role}</span>
                </span>
              </figcaption>
            </motion.figure>
          </AnimatePresence>

          <div className="mt-8 flex items-center justify-center gap-4" data-id="element-278">
            <button type="button" onClick={() => go(-1)} aria-label="Prethodno iskustvo" className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-ink transition-colors hover:bg-cream" data-id="element-279">
              <ChevronLeftIcon className="h-5 w-5" data-id="element-280" />
            </button>
            <div className="flex gap-2" data-id="element-281">
              {testimonials.map((_, i) => <button key={i} type="button" onClick={() => setIndex(i)} aria-label={`Iskustvo ${i + 1}`} className={`h-2.5 rounded-full transition-all ${i === index ? 'w-8 bg-gold' : 'w-2.5 bg-gold/30'}`} data-id="element-282" />)}
            </div>
            <button type="button" onClick={() => go(1)} aria-label="Sljedeće iskustvo" className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/40 text-ink transition-colors hover:bg-cream" data-id="element-283">
              <ChevronRightIcon className="h-5 w-5" data-id="element-284" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}